import { put, call } from 'redux-saga/effects';
import { ppSettingsList, ppSettingsAdd, ppSettingsEdit, ppSettingsUpdate, ppSettingsDelete } from '../../../services/settings/superadmin/ppSettingService';

import * as types from '../../../actions';

export function* ppSettingsListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(ppSettingsList, payload);
      yield put({ type: types.OMNU_POINTS_PP_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.OMNU_POINTS_PP_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
  }

export function* ppSettingsAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(ppSettingsAdd, payload);
      yield put({ type: types.OMNU_POINTS_PP_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.OMNU_POINTS_PP_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* ppSettingsEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(ppSettingsEdit, payload);
    yield put({ type: types.OMNU_POINTS_PP_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.OMNU_POINTS_PP_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* ppSettingsUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(ppSettingsUpdate, payload);
    yield put({ type: types.OMNU_POINTS_PP_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.OMNU_POINTS_PP_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* ppSettingsDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(ppSettingsDelete, payload);
    yield put({ type: types.OMNU_POINTS_PP_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.OMNU_POINTS_PP_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}